import styled from "styled-components";

export const JBOptInReminderTextContentDefaultBox = styled.div`
    font-size: 1.4rem;
    font-weight: 600;
    padding-bottom: 16px;
    text-align: center;
`;
